import ROLES from '@/constants/roles'

export default function ({ redirect, $strapi }) {
  if ($strapi.user.role.type !== ROLES.RELINK) {
    return redirect('/inicio')
  }
}
